import React from "react";
import { Avatar, Tag } from "antd";
import { useMetadataStore } from "@ifa/utils";
import { CloseOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";
import type { SelectedMemberCardProps } from "./types";
import { getPersonnelTypeLabel } from "./utils/personnelType";
import styles from "./SelectedMemberCard.module.css";

const SelectedMemberCard: React.FC<SelectedMemberCardProps> = ({
  member,
  onRemove,
}) => {
  const selectMetadataList = useMetadataStore(
    (state) => state.selectMetadataList
  );
  const personnelTypeLabel = getPersonnelTypeLabel(
    member.personnelType,
    selectMetadataList
  );

  return (
    <div className={styles.card}>
      <Avatar size={28} className={styles.avatar} icon={<UserOutlined />}>
        {member.name?.charAt(0)}
      </Avatar>

      <div className={styles.content}>
        <div className={styles.topRow}>
          <div className={styles.mainInfo}>
            <div className={styles.name}>{member.name}</div>
            <div className={styles.empNo}>{member.empNo || "暫無工號"}</div>
          </div>

          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              onRemove(member.uid);
            }}
            className={styles.removeButton}
          >
            <CloseOutlined className={styles.removeIcon} />
          </button>
        </div>

        <div className={styles.bottomRow}>
          <div className={styles.teamLine}>
          <TeamOutlined />
          <span className={styles.teamText}>{member.teamName || "未歸屬團隊"}</span>
          </div>

          {personnelTypeLabel ? (
            <div className={styles.tags}>
              <Tag bordered={false} className={`${styles.tag} ${styles.tagNeutral}`}>
                {personnelTypeLabel}
              </Tag>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default React.memo(SelectedMemberCard);
